import { Fragment } from "react";
import assets from "../../assets";
import useHandler from "./handler";
import { LANGUAGE_OPTIONS } from "../../utils/constant";
import { CommonPopup } from "../../components/pop-up";
import { ROUTE_LEARNING_ASSETS } from "../../route/tnpscRoute";
import "./styles.sass";

export const AiGenerator = () => {
  const {
    isValidateVideoContent,
    user,
    medium,
    handleExistingAssets,
    handleDurationChange,
    filteredDurationOptions,
    navigate,
    popupData,
    setPopupData,
    role,
    togglebtn,
    selectedPart,
    addConcept,
    deleteConcept,
    lessons,
    subjects,
    isFormValid,
    openDropdown,
    selectedLanguage,
    getLessonDetails,
    languageRef,
    assetPopupOpen,
    setAssetPopupOpen,
    subjectRef,
    setSelectedUnit,
    units,
    subjectOptions,
    filteredAssets,
    setFilteredAssets,
    preferredType,
    selectMode,
    selectedMedium,
    selectedSubject,
    selectedUnit,
    addUnit,
    deleteUnit,
    chapters,
    duration,
    durationType,
    durationDropdown,
    isLoading,
    partRef,
    unitRef,
    lessonRef,
    selectedLesson,
    setSelectedLesson,
    getChapterDetails,
    setSelectedSubject,
    setSubjects,
    setConceptText,
    setOpenDropdown,
    setSelectedLanguage,
    setPreferredType,
    setSelectedPart,
    setSelectMode,
    setSelectedMedium,
    addChapters,
    deleteChapter,
    aiGenerate,
    resetForm,
    aiLongGenerate,
    aiRandomGenerate,
    setDuration,
    setDurationType,
    setDurationDropdown,
    conceptOptions,
    getConceptDetails,
    generateVideoContent,
    toggleNotify,
  } = useHandler();

  const LIMITS = {
    short: 1,
    long: 3,
    random: 1,
  };

  console.log(selectedPart, "selectedUnit");

  const maxChapters = LIMITS[selectMode];

  const renderSubjectsWrapperLong = (item, index) => {
    const { name, id } = item || {};
    const hasLessons = item?.units?.some((unit) =>
      unit?.chapters?.some(
        (chap) => chap?.lesson || (chap?.lessons && chap.lessons.length > 0),
      ),
    );
    return (
      <section key={id} className="chapter_container_wrapper">
        {/* SUBJECT */}
        <section className="subject_chapter_container" ref={subjectRef}>
          <section
            className="desc_drop_down_wrapper"
            onClick={() => {
              setOpenDropdown({
                type: "subject",
                subjectId: item.id,
              });
            }}
          >
            <h5>{name || "Select Part"}</h5>
            <img src={assets.ic_chevron_down} alt="chevron_down" />
          </section>

          {openDropdown?.type === "subject" &&
            openDropdown?.subjectId === item.id && (
              <section className="desc_options_list">
                {subjectOptions?.map((sub, i) => {
                  console.log(sub, "sub");
                  return (
                    <p
                      key={i}
                      className="desc_option_item"
                      onMouseDown={(e) => {
                        e.stopPropagation();
                        setSubjects((prev) =>
                          prev.map((s) =>
                            s.id === item.id ? { ...s, name: sub } : s,
                          ),
                        );

                        setSelectedSubject({ id: item.id, name: sub });

                        setSelectedPart(sub); // ✅ VERY IMPORTANT

                        setOpenDropdown(null);
                      }}
                    >
                      {sub}
                    </p>
                  );
                })}
              </section>
            )}
        </section>
        {subjects.length >= 1 && (
          <section className="min_chapter_alter_wrapper">
            <img src={assets.ic_alert} alt="ic_alert" />
            <h6>Maximum parts reached</h6>
          </section>
        )}

        {/* UNIT HEADER */}
        <section className="min_chapter_wrapper">
          <section className="min_content_wrapper">
            {selectMode !== "random" && (
              <>
                <img src={assets.ic_book} alt="" />
                <h4>unit</h4>
                <h5>Maximum 3 Units per part</h5>
              </>
            )}
          </section>
          {(selectMode !== "random" || item?.units?.length < 1) && (
            <section
              className="add_btn_wrapper"
              onClick={() => addUnit(item.id)}
            >
              <img src={assets.ic_add} alt="" />
              <h5>Add Unit</h5>
            </section>
          )}
        </section>

        {/* UNIT LIST */}
        {item?.units?.map((unit, uIndex) => (
          <section key={unit.id} className="chapter_container_wrapper">
            {/* UNIT */}
            <section className="subject_chapter_container">
              <section className="select_box1">U{uIndex + 1}</section>

              <section
                className="desc_drop_down_wrapper"
                onClick={() =>
                  setOpenDropdown({
                    type: "unit",
                    subjectId: item.id,
                    unitId: unit.id,
                  })
                }
              >
                <h5>{unit.name || "Select Unit"}</h5>
                <img src={assets.ic_chevron_down} alt="" />
              </section>

              {selectMode !== "random" && (
                <img
                  src={assets.ic_subject_delete}
                  alt=""
                  className="subject_delete"
                  onClick={() => deleteUnit(item.id, unit.id)}
                />
              )}

              {openDropdown?.type === "unit" &&
                openDropdown?.unitId === unit.id && (
                  <section className="desc_options_list">
                    {units?.map((u, i) => (
                      <p
                        key={i}
                        className="desc_option_item"
                        onMouseDown={(e) => {
                          e.stopPropagation();
                          setSelectedUnit(u);

                          setSubjects((prev) =>
                            prev.map((s) =>
                              s.id === item.id
                                ? {
                                    ...s,
                                    units: s.units.map((uu) =>
                                      uu.id === unit.id
                                        ? { ...uu, name: u }
                                        : uu,
                                    ),
                                  }
                                : s,
                            ),
                          );
                          setOpenDropdown(null);
                        }}
                      >
                        {u}
                      </p>
                    ))}
                  </section>
                )}
            </section>

            {/* ADD CHAPTER */}
            {unit?.chapters?.length < maxChapters && (
              <section className="min_chapter_wrapper">
                <section className="min_content_wrapper">
                  {selectMode !== "random" && (
                    <>
                      <img src={assets.ic_book} alt="" />
                      <h4>Chapters</h4>
                      <h5>Maximum 1 chapter per unit</h5>
                    </>
                  )}
                </section>

                <section
                  className="add_btn_wrapper"
                  onClick={() => addChapters(item.id, unit.id)}
                >
                  <img src={assets.ic_add} alt="" />
                  <h5>Add Chapter</h5>
                </section>
              </section>
            )}
            {/* CHAPTER LIST */}
            {unit?.chapters?.map((chap, cIndex) => (
              <Fragment key={chap.id}>
                {/* ---------- CHAPTER ---------- */}
                <section className="subject_chapter_container">
                  <section className="select_box1">C{cIndex + 1}</section>

                  <section
                    className="desc_drop_down_wrapper"
                    onClick={() =>
                      setOpenDropdown({
                        type: "chapter",
                        subjectId: item.id,
                        unitId: unit.id,
                        chapterId: chap.id,
                      })
                    }
                  >
                    <h5>{chap.name || "Select Chapter"}</h5>
                    <img src={assets.ic_chevron_down} alt="" />
                  </section>

                  {selectMode !== "random" && (
                    <img
                      src={assets.ic_subject_delete}
                      alt=""
                      className="subject_delete"
                      onClick={() => deleteChapter(item.id, unit.id, chap.id)}
                    />
                  )}

                  {openDropdown?.type === "chapter" &&
                    openDropdown?.chapterId === chap.id && (
                      <section className="desc_options_list">
                        {chapters?.map((ch, i) => (
                          <p
                            key={i}
                            className="desc_option_item"
                            onMouseDown={(e) => {
                              e.stopPropagation();

                              setSubjects((prev) =>
                                prev.map((s) =>
                                  s.id === item.id
                                    ? {
                                        ...s,
                                        units: s.units.map((u) =>
                                          u.id === unit.id
                                            ? {
                                                ...u,
                                                chapters: u.chapters.map((c) =>
                                                  c.id === chap.id
                                                    ? { ...c, name: ch }
                                                    : c,
                                                ),
                                              }
                                            : u,
                                        ),
                                      }
                                    : s,
                                ),
                              );

                              getLessonDetails({
                                board: user?.data?.board,
                                clas: user?.data?.class,
                                medium: medium,
                                part: selectedPart,
                                unit: unit.name,
                                chapter: ch,
                              });

                              setOpenDropdown(null);
                            }}
                          >
                            {ch}
                          </p>
                        ))}
                      </section>
                    )}
                </section>

                {/* ---------- LESSON ---------- */}
                {selectMode !== "random" && (
                  <>
                    <section className="subject_chapter_container">
                      <section className="select_box1">L</section>
                      <section
                        className="desc_drop_down_wrapper"
                        onClick={() =>
                          setOpenDropdown({
                            type: "lesson",
                            subjectId: item.id,
                            unitId: unit.id,
                            chapterId: chap.id,
                          })
                        }
                      >
                        <h5>
                          {selectMode === "short"
                            ? chap.lesson || "Select Lesson"
                            : selectMode === "long"
                              ? chap.lessons?.length
                                ? chap.lessons.join(", ")
                                : "Select Lesson"
                              : "Select Lesson"}
                        </h5>

                        <img src={assets.ic_chevron_down} alt="" />
                      </section>

                      {openDropdown?.type === "lesson" &&
                        openDropdown?.chapterId === chap.id && (
                          <section className="desc_options_list">
                            {lessons?.map((lesson, i) => (
                              <p
                                key={i}
                                className="desc_option_item"
                                onMouseDown={(e) => {
                                  e.stopPropagation();

                                  setSubjects((prev) =>
                                    prev.map((s) =>
                                      s.id === item.id
                                        ? {
                                            ...s,
                                            units: s.units.map((u) =>
                                              u.id === unit.id
                                                ? {
                                                    ...u,
                                                    chapters: u.chapters.map(
                                                      (c) => {
                                                        if (c.id !== chap.id)
                                                          return c;

                                                        // ✅ SHORT MODE → ONLY ONE LESSON
                                                        if (
                                                          selectMode === "short"
                                                        ) {
                                                          return {
                                                            ...c,
                                                            lesson, // single string
                                                            lessons: [], // reset array (important)
                                                          };
                                                        }

                                                        // ✅ LONG MODE → MAX 2 LESSONS
                                                        if (
                                                          selectMode === "long"
                                                        ) {
                                                          const existing =
                                                            c.lessons || [];

                                                          if (
                                                            existing.includes(
                                                              lesson,
                                                            )
                                                          )
                                                            return c;
                                                          if (
                                                            existing.length >= 2
                                                          )
                                                            return c;

                                                          return {
                                                            ...c,
                                                            lessons: [
                                                              ...existing,
                                                              lesson,
                                                            ],
                                                          };
                                                        }

                                                        return c;
                                                      },
                                                    ),
                                                  }
                                                : u,
                                            ),
                                          }
                                        : s,
                                    ),
                                  );

                                  getConceptDetails({
                                    board: user?.data?.board,
                                    clas: user?.data?.class,
                                    medium: medium,
                                    part: selectedPart,
                                    unit: unit.name,
                                    chapter: chap.name,
                                    lesson: lesson,
                                  });

                                  setOpenDropdown(null);
                                }}
                              >
                                {lesson}
                              </p>
                            ))}
                          </section>
                        )}
                    </section>
                    <h5 className="max-les">Maximum 2 lessons per chapter</h5>
                  </>
                )}
                {selectMode === "long" && chap?.lessons?.length < 2 && (
                  <section
                    className="add_btn_wrapper"
                    onClick={() =>
                      setOpenDropdown({
                        type: "lesson",
                        subjectId: item.id,
                        unitId: unit.id,
                        chapterId: chap.id,
                      })
                    }
                  >
                    <img src={assets.ic_add} alt="" />
                    <h5>Add Lesson</h5>
                  </section>
                )}
                <section className="add_chapters_wrapper">
                  {chap?.lessons?.map((lesson, i) => (
                    <section key={i} className="add_chapters">
                      <h6>{lesson}</h6>
                      <img
                        src={assets.ic_close_white}
                        alt="remove"
                        onClick={() => {
                          setSubjects((prev) =>
                            prev.map((s) =>
                              s.id === item.id
                                ? {
                                    ...s,
                                    units: s.units.map((u) =>
                                      u.id === unit.id
                                        ? {
                                            ...u,
                                            chapters: u.chapters.map((c) =>
                                              c.id === chap.id
                                                ? {
                                                    ...c,
                                                    lessons: c.lessons.filter(
                                                      (_, index) => index !== i,
                                                    ),
                                                  }
                                                : c,
                                            ),
                                          }
                                        : u,
                                    ),
                                  }
                                : s,
                            ),
                          );
                        }}
                      />
                    </section>
                  ))}
                </section>

                {!togglebtn &&
                  (selectMode === "short" || selectMode === "long") && (
                    <Fragment>
                      <section className="concept_desc_wrapper">
                        <section className="concept_desc">
                          <img src={assets.ic_plub} alt="ic_plub" />
                          Concepts (Select{" "}
                          {role === "guest" ? "only 1" : "up to 3"})
                        </section>

                        <h6>
                          {chap?.concepts?.length} of {role === "guest" ? 1 : 3}{" "}
                          selected
                        </h6>
                      </section>
                      {/* ✅ SAME AS LESSON STRUCTURE */}
                      <section className="subject_chapter_container">
                        {/* ✅ LEFT LABEL LIKE LESSON */}
                        <section className="select_box1">C</section>

                        {/* ✅ DROPDOWN INPUT */}
                        <section
                          className="desc_drop_down_wrapper"
                          onClick={() =>
                            setOpenDropdown({
                              type: "concept",
                              subjectId: item.id,
                              unitId: unit.id,
                              chapterId: chap.id,
                            })
                          }
                        >
                          <h5>
                            {chap?.concepts?.length
                              ? chap.concepts.join(", ")
                              : "Select Concepts"}
                          </h5>
                          <img src={assets.ic_chevron_down} alt="" />
                        </section>

                        {/* ✅ DROPDOWN OPTIONS (SAME CLASS AS LESSON) */}
                        {openDropdown?.type === "concept" &&
                          openDropdown?.chapterId === chap.id && (
                            <section className="desc_options_list">
                              {conceptOptions?.length > 0 ? (
                                conceptOptions.map((concept, i) => (
                                  <p
                                    key={i}
                                    className="desc_option_item"
                                    onMouseDown={(e) => {
                                      e.stopPropagation();

                                      addConcept(
                                        item.id,
                                        unit.id,
                                        chap.id,
                                        concept,
                                      );
                                    }}
                                  >
                                    {concept}
                                  </p>
                                ))
                              ) : (
                                <p className="desc_option_item">No concepts found</p>
                              )}
                            </section>
                          )}
                      </section>

                      {/* ✅ CHIPS (NO CHANGE) */}
                      <section className="add_chapters_wrapper">
                        {chap?.concepts?.map((concept, i) => (
                          <section key={i} className="add_chapters">
                            <h6>{concept}</h6>
                            <img
                              src={assets.ic_close_white}
                              alt="remove"
                              onClick={() =>
                                deleteConcept(item.id, unit.id, chap.id, i)
                              }
                            />
                          </section>
                        ))}
                        {chap?.concepts?.length >= 3 && (
                          <section className="min_chapter_alter_wrapper">
                            <img src={assets.ic_alert} alt="ic_alert" />
                            <h6>Maximum concepts reached</h6>
                          </section>
                        )}
                      </section>
                    </Fragment>
                  )}
              </Fragment>
            ))}
          </section>
        ))}

        {!hasLessons && selectMode !== "random" && (
          <section className="empty_chap_info_wrapper">
            <img src={assets.ic_info} alt="ic_info" />
            <h6 className="no_chap_text">No Lessons added yet</h6>
            <h6 className="add_chap_yet">Click "Add Unit" to get started</h6>
          </section>
        )}
      </section>
    );
  };

  return (
    <section>
      <section className="main_wrapper">
        <div className="la-banner-dynamic gen-banner">
        <div className="la-banner-content">
          <span className="la-banner-badge">AI Content Lab</span>
          <h2 className="la-banner-title">TNPSC AI Lesson Generator</h2>
          <p className="la-banner-desc">
            Select your target Part, Unit, and Chapter to generate high-quality 
            educational content powered by advanced artificial intelligence.
          </p>
          <div className="la-banner-features">
            <div className="feature-item">
              <span className="check-icon">✓</span>
              <span>Personalized Learning</span>
            </div>
            <div className="feature-item">
              <span className="check-icon">✓</span>
              <span>Multi-Format Output</span>
            </div>
            <div className="feature-item">
              <span className="check-icon">✓</span>
              <span>TNPSC Standard Mapping</span>
            </div>
          </div>
        </div>
        <div className="gen-banner-icon">
          <img src={assets.ic_generate_magic} alt="magic" />
        </div>
      </div>
        <section className="content_info_container">
          <section className="contentai_info_container">
            <section className="info_box">
              <img src={assets.ic_info_outline} alt="ic_info" />
            </section>
            <section>
              <h4>Content Generation Information</h4>
              <section className="content_ai_desc">
                <h5>
                  Competitive Exam:{" "}
                  <span className="ai_board">
                    {`${user?.data?.class}` || "Grade 10"}
                  </span>
                </h5>
              </section>
            </section>

            {/* MEDIUM */}
            <section className="ai_default_medium_wrapper">
              <h4>Medium</h4>
              <h5>{user?.data?.medium}</h5>
            </section>
          </section>
          <section className="content_setting_lang">
            <section className="lanuage_wrapper" ref={languageRef}>
              <h5>Content Language</h5>
              <section
                className="desc_drop_down_wrapper"
                onClick={() => setOpenDropdown("language")}
              >
                <h5>{selectedLanguage || "Select Language"}</h5>
                <img src={assets.ic_chevron_down} alt="chevron_down" />
              </section>
              {openDropdown === "language" && (
                <section className="desc_options_list">
                  {LANGUAGE_OPTIONS.map((item, i) => (
                    <p
                      key={i}
                      className="desc_option_item"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedLanguage(item);
                        setOpenDropdown(null);
                      }}
                    >
                      {item}
                    </p>
                  ))}
                </section>
              )}
            </section>
            <section className="preferred_content_wrapper">
              <h4>Content type</h4>
              <section className="preferred_type_container">
                <section
                  className={
                    preferredType === "video"
                      ? "preferred_video"
                      : "preferred_type"
                  }
                  onClick={() => {
                    if (role === "guest") {
                      toggleNotify({
                        type: "success",
                        title: "Message",
                        description: "Please Subscribe",
                      });
                    } else {
                      setSelectedPart("");
                      setSelectedUnit("");
                      setSelectedSubject("");
                      setSelectedLesson("");
                      setPreferredType("video");
                    }
                  }}
                >
                  <img src={assets.ic_youtube} alt="ic_youtube" />
                  <h5> Video</h5>
                </section>
                <section
                  className={
                    preferredType === "audio"
                      ? "preferred_video"
                      : "preferred_type"
                  }
                  onClick={() => setPreferredType("audio")}
                >
                  <img src={assets.ic_volume_green} alt="ic_volume_green" />
                  <h5>Audio</h5>
                </section>
              </section>
            </section>
          </section>
          {preferredType !== "video" && (
            <section className="short-tab-wrapper">
              <section>
                <section
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <h4>Content Generator Settings</h4>
                  <img
                    src={assets.ic_info_outline}
                    alt="info_outline"
                    style={{ width: "16px", height: "16px" }}
                  />
                </section>
                <h5 className="choose_text">
                  Choose between Short, Long and Custom content generation{" "}
                </h5>
              </section>
              <section className="short_long_wrapper">
                {/* SHORT */}
                <section
                  className={`mode_item ${selectMode === "short" ? "active" : ""}`}
                  onClick={() => setSelectMode("short")}
                  style={{ position: "relative" }}
                >
                  <section className="dot"></section>
                  <h5>Short Content</h5>
                  <div className="mode_tooltip">
                    Quick, high-level audio/video summaries for specific topics. Perfect for rapid review.
                    <br /><strong>⏱ ~30 seconds</strong>
                  </div>
                </section>

                {/* LONG */}
                <section
                  className={`mode_item ${selectMode === "long" ? "active" : ""}`}
                  onClick={() => {
                    if (role === "guest") {
                      toggleNotify({
                        type: "success",
                        title: "Message",
                        description: "Please Subscribe",
                      });
                    } else {
                      setSelectMode("long");
                    }
                  }}
                  style={{ position: "relative" }}
                >
                  <section className="dot"></section>
                  <h5>Long Content</h5>
                  <div className="mode_tooltip">
                    In-depth, full-chapter audio/video content. Best for comprehensive learning and deep dives.
                    <br /><strong>⏱ ~5–10 minutes</strong>
                  </div>
                </section>

                {/* CUSTOM */}
                <section
                  className={`mode_item ${selectMode === "random" ? "active" : ""}`}
                  onClick={() => setSelectMode("random")}
                  style={{ position: "relative" }}
                >
                  <section className="dot"></section>
                  <h5>Custom</h5>
                  <div className="mode_tooltip">
                    Personalized content generated to your specific filters and duration preferences.
                    <br /><strong>⏱ You choose the duration</strong>
                  </div>
                </section>
              </section>
              {selectMode === "random" && (
                <section className="preferred_duration_wrapper">
                  <h4>Duration</h4>
                  <section className="duration_input_wrapper">
                    <input
                      type="number"
                      placeholder="Example: 1"
                      value={duration}
                      onChange={(e) => {
                        const value = e.target.value.slice(0, 2);
                        handleDurationChange(value);
                      }}
                    />
                    <section
                      className="duration_dropdown"
                      onClick={() => setDurationDropdown(!durationDropdown)}
                    >
                      <p>{durationType}</p>
                      <img src={assets.ic_chevron_down} alt="dropdown" />
                    </section>
                  </section>
                  {durationDropdown && (
                    <section className="duration_options">
                      {filteredDurationOptions?.map((item, i) => (
                        <p
                          key={i}
                          onMouseDown={(e) => {
                            e.stopPropagation();
                            setDurationType(item);
                            setDurationDropdown(false);
                          }}
                        >
                          {item}
                        </p>
                      ))}
                    </section>
                  )}
                </section>
              )}
            </section>
          )}
        </section>
        <section className="subject_content_container">
          <img src={assets.ic_select_subject} alt="select_subject" />
          <section>
            <h4>Part</h4>
            <h5>
              {preferredType === "video"
                ? "Maximum 1 part allowed"
                : "1 Part only allowed"}
            </h5>
          </section>
        </section>
        {preferredType !== "video" && (
          <section>{subjects?.map(renderSubjectsWrapperLong)}</section>
        )}
        {preferredType === "video" && (
          <section className="preffered_type_video_wrapper">
            <section>
              <section
                ref={partRef}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDropdown("part");
                }}
              >
                <h4>part</h4>
                <section className="preffered_type_drop_down_wrapper">
                  <p>{selectedPart || "Select Part"}</p>
                  <img src={assets.ic_chevron_down} alt="ic_chevron_down" />
                </section>
              </section>
              {openDropdown === "part" && (
                <section className="preferred_type_option_list">
                  {isLoading ? (
                    <p
                      style={{
                        textAlign: "center",
                        marginTop: "40px",
                        color: "green",
                      }}
                    >
                      Loading part...
                    </p>
                  ) : subjectOptions?.length > 0 ? (
                    subjectOptions?.map((item, i) => {
                      return (
                        <p
                          key={i}
                          className="preferred_type_option_item"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedPart(`${item}`);
                            setTimeout(() => {
                              setOpenDropdown(null);
                            }, 0);
                          }}
                        >
                          {item}
                        </p>
                      );
                    })
                  ) : (
                    <p
                      style={{
                        textAlign: "center",
                        marginTop: "40px",
                        color: "red",
                      }}
                    >
                      No parts found
                    </p>
                  )}
                </section>
              )}
            </section>
            <section className="perffered_type_subject_wrapper">
              <section
                ref={subjectRef}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDropdown("subject");
                }}
              >
                <h4>Unit</h4>
                <section className="preffered_type_drop_down_wrapper">
                  <p>{selectedUnit || "Select Unit"}</p>
                  <img src={assets.ic_chevron_down} alt="ic_chevron_down" />
                </section>
              </section>
              {openDropdown === "subject" && (
                <section className="preferred_type_option_list">
                  {!selectedPart ? (
                    <p
                      style={{
                        textAlign: "center",
                        marginTop: "40px",
                        color: "green",
                      }}
                    >
                      Please first Choose Part
                    </p>
                  ) : isLoading ? (
                    <p
                      style={{
                        textAlign: "center",
                        marginTop: "40px",
                        color: "green",
                      }}
                    >
                      Loading units...
                    </p>
                  ) : units?.length > 0 ? (
                    units?.map((item, i) => {
                      console.log(item, "item");
                      return (
                        <p
                          key={i}
                          className="preferred_type_option_item"
                          onClick={(e) => {
                            e.stopPropagation();
                            console.log("CLICK WORKING");
                            setSelectedUnit(`${item}`);
                            setTimeout(() => {
                              setOpenDropdown(null);
                            }, 0);
                          }}
                        >
                          {item}
                        </p>
                      );
                    })
                  ) : (
                    <p
                      style={{
                        textAlign: "center",
                        marginTop: "40px",
                        color: "red",
                      }}
                    >
                      No units found
                    </p>
                  )}
                </section>
              )}
            </section>
            <section className="perffered_type_subject_wrapper">
              <section
                ref={unitRef}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDropdown("unit");
                }}
              >
                <h4>Chapter</h4>
                <section className="preffered_type_drop_down_wrapper">
                  <p>{selectedSubject || "Select Chapter"}</p>
                  <img src={assets.ic_chevron_down} alt="ic_chevron_down" />
                </section>
              </section>
              {openDropdown === "unit" && (
                <section className="preferred_type_option_list">
                  {!selectedUnit ? (
                    <p
                      style={{
                        textAlign: "center",
                        marginTop: "40px",
                        color: "green",
                      }}
                    >
                      Please first Choose Unit
                    </p>
                  ) : isLoading ? (
                    <p
                      style={{
                        textAlign: "center",
                        marginTop: "40px",
                        color: "green",
                      }}
                    >
                      Loading chapters...
                    </p>
                  ) : chapters?.length > 0 ? (
                    chapters?.map((item, i) => {
                      console.log(item, "item");
                      return (
                        <p
                          key={i}
                          className="preferred_type_option_item"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedSubject(`${item}`);
                            setTimeout(() => {
                              setOpenDropdown(null);
                            }, 0);
                          }}
                        >
                          {item}
                        </p>
                      );
                    })
                  ) : (
                    <p
                      style={{
                        textAlign: "center",
                        marginTop: "40px",
                        color: "red",
                      }}
                    >
                      No chapters found
                    </p>
                  )}
                </section>
              )}
            </section>
            <section className="perffered_type_subject_wrapper">
              <section
                ref={lessonRef}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDropdown("lesson");
                }}
              >
                <h4>Lesson</h4>
                <section className="preffered_type_drop_down_wrapper">
                  <p>{selectedLesson || "Select Lesson"}</p>
                  <img src={assets.ic_chevron_down} alt="ic_chevron_down" />
                </section>
              </section>
              {openDropdown === "lesson" && (
                <section className="preferred_type_option_list">
                  {!selectedSubject ? (
                    <p
                      style={{
                        textAlign: "center",
                        marginTop: "40px",
                        color: "green",
                      }}
                    >
                      Please first Choose Chapter
                    </p>
                  ) : isLoading ? (
                    <p
                      style={{
                        textAlign: "center",
                        marginTop: "40px",
                        color: "green",
                      }}
                    >
                      Loading Lessons...
                    </p>
                  ) : lessons?.length > 0 ? (
                    lessons?.map((item, i) => {
                      console.log(item, "item");
                      return (
                        <p
                          key={i}
                          className="preferred_type_option_item"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedLesson(`${item}`);
                            setTimeout(() => {
                              setOpenDropdown(null);
                            }, 0);
                          }}
                        >
                          {item}
                        </p>
                      );
                    })
                  ) : (
                    <p
                      style={{
                        textAlign: "center",
                        marginTop: "40px",
                        color: "red",
                      }}
                    >
                      No lessons found
                    </p>
                  )}
                </section>
              )}
            </section>
          </section>
        )}
        {/* <section className="add_subject_wrapper" onClick={addSubject}>
        <img src={assets.ic_add_white} alt="ic_add_white" />
        <h5>Add Part</h5>
      </section> */}

        <CommonPopup
          open={popupData.open}
          title={popupData.title}
          description={popupData.description}
          buttonText={popupData.buttonText}
          onClose={() => setPopupData((prev) => ({ ...prev, open: false }))}
          onConfirm={async () => {
            const id = popupData.assetId;

            setPopupData((prev) => ({ ...prev, open: false }));

            if (id) {
              const assets = await handleExistingAssets(id);

              if (assets?.length > 0) {
                setAssetPopupOpen(true); // ✅ open 2nd popup
              }
            } else {
              navigate(ROUTE_LEARNING_ASSETS);
            }
          }}
        />
        <CommonPopup
          open={assetPopupOpen}
          url={true}
          onClose={() => setAssetPopupOpen(false)}
        >
          {filteredAssets.map((asset) => (
            <div key={asset.asset_id}>
              {asset.type === "video" && (
                <video width="800" controls>
                  <source src={asset.url} type="video/mp4" />
                </video>
              )}

              {asset.type === "audio" && (
                <audio controls>
                  <source src={asset.url} type="audio/mpeg" />
                </audio>
              )}
            </div>
          ))}
        </CommonPopup>
      </section>
      <section className="footer_btns_wrapper">

        <section className="form_btns">
          <section className="reset_form" onClick={resetForm}>
            <img src={assets.ic_refresh_blue} alt="ic_refresh_blue" />
            <h5>Reset Form</h5>
          </section>

          {preferredType !== "video" ? (
            <button
              className="generate_btn"
              onClick={() => {
                if (selectMode === "short") {
                  aiGenerate();
                } else if (selectMode === "long") {
                  aiLongGenerate();
                } else if (selectMode === "random") {
                  aiRandomGenerate();
                }
              }}
              disabled={!isFormValid()}
            >
              <img src={assets.ic_generate_magic} alt="ic_generate_magic" />
              <h5>Generate Content</h5>
            </button>
          ) : (
            <button
              className="generate_btn"
              onClick={generateVideoContent}
              disabled={isValidateVideoContent}
            >
              <img src={assets.ic_generate_magic} alt="ic_generate_magic" />
              <h5>Generate Content</h5>
            </button>
          )}
        </section>
      </section>
    </section>
  );
};
